import { Box, CircularProgress, Divider } from "@mui/joy";
import { Plus } from "lucide-react";
import { Link, useNavigate } from "react-router-dom";

import { DataGridSetting } from "../../../../components";
import { Button } from "../../../../shared";
import { useSupplier } from "../../../../hooks/query";

import { columnDef } from "./column-def";
import Breadcrumb from "./Breadcrumb";

import type { ISupplier } from "../../../../interfaces";

export default function List() {
    const { useList } = useSupplier();
    const { data, isLoading, isError, error } = useList();

    if (isLoading) {
        return (
            <Box flex={1} display="flex" justifyContent="center" alignItems="center">
                <CircularProgress />
            </Box>
        );
    }

    if (isError) {
        return (
            <Box flex={1} p={2}>
                <Box sx={{ color: "danger.plainColor" }}>
                    {error instanceof Error ? error.message : "Failed to load suppliers"}
                </Box>
            </Box>
        );
    }

    const suppliers = (data as ISupplier[]) || [];

    return (
        <Box flex={1} display={"flex"} flexDirection={"column"}>
            <Breadcrumb />
            <Divider />
            <Box flex={1}>
                <DataGridSetting
                    gridData={suppliers}
                    columnDefs={columnDef}
                    quickControlStartDecorator={<CreateSupplierButton />}
                />
            </Box>
        </Box>
    );
}

function CreateSupplierButton() {
    return (
        <Box display="flex" alignItems={"center"} ml={1.5}>
            <Button
                variant="soft"
                color="primary"
                component={Link}
                to="/suppliers/new"
                startDecorator={<Plus size={18} />}
            >
                Create Supplier
            </Button>
            <Divider orientation="vertical" sx={{ mt: 1, mb: 1, ml: 2 }} />
        </Box>
    );
}
